import * as React from "react"
import {
  Edit,
} from "react-admin"
import LogoForm from "./LogoForm"

const LogoTitle = () => {
  return <span>{'LOGO'}</span>
}

const LogoEdit = () => {
  return (
    <Edit 
      title={<LogoTitle/>} 
      redirect={false} 
      mutationMode="optimistic"
    >
      <LogoForm 
        formType="edit" 
      />
    </Edit>
  )
}

export default LogoEdit